import React from 'react';

import { CreateDealWithAiModal } from 'bundles/apex/ai/create_deal/modal';
import { useStandaloneTool } from '../context';

import type { Deal } from 'bundles/apex/deals/types';

export function CreateDeal() {
  const { call, closeTool } = useStandaloneTool('create_deal');

  function onCreate(deal: Deal) {
    if (deal.path) {
      window.location.assign(deal.path);
    }
  }

  const props = call?.metadata ?? null;

  return (
    <CreateDealWithAiModal
      autoSubmit
      initialAttachment={props?.attachment}
      initialDealType={props?.dealType}
      initialStage={props?.stage}
      initialText={props?.text}
      open={!!props}
      onClose={closeTool}
      onCreate={onCreate}
    />
  );
}
